const constants = {
  welcomeMessage: "Bienvenido a CeliMapp",
  logout: "Cerrar sesión",
  title: "Dashboard",
};
export default constants;
